/**
 * Toggles between sections
 */

$(function(){
  $('.js-section-link').each(function() {
    let currUrl = new URL(window.location.href);
    let param = currUrl.searchParams.get('filter');
    if(param && $(this) && param === $(this).attr('data-container')) {
      $(this).addClass('active');
    }
    if(param && $(this)) {
      if( param !== $(this).attr('data-container')) {
        $('#' + $(this).attr('data-container')).fadeOut(500);
      }
    }
    if($(this).attr('data-container') == "recents" && document.querySelectorAll('.js-question-item').length > 0) {
      $('#' + $(this).attr('data-container')).fadeOut(500);
    }
  });
  $(".js-section-link").on('click', function(){
    $('.js-section-link').each(function() {
      $(this).removeClass('active');
    });
    $(this).addClass('active');
    let currUrl = new URL(window.location.href);
    if(currUrl.searchParams.get('filter') === null || currUrl.searchParams.get('filter') === undefined){
      window.location.href = window.location.href + '?filter='+$(this).attr('data-container');
    } else {
      currUrl.searchParams.set('filter', $(this).attr('data-container'))
      window.location.href = currUrl;
    }
  });
});

function toggleSection(container, pagination) {
  $('.js-category-container').each(function () {
    if ($(this).attr('id') == container) {
      //$(this).removeClass('d-none');
      $(this).fadeIn(500);
    } else {
      $(this).fadeOut(1);
    }
  });

  $('.js-pagination').each(function () {
    if ($(this).hasClass(pagination)) {
      $(this).fadeIn(500);
      //$(this).removeClass('d-none');
    } else {
      $(this).fadeOut(1);
      //$(this).addClass('d-none');
    }
  })
}
